import { Checkbox, PanelType, PrimaryButton, Stack } from 'office-ui-fabric-react';
import React, { Component } from 'react';
import Scriba from 'react-scriba';
import { TYPES_DOCUMENT } from '../../../data/DataDocument';
import { DataDocumentOperationCategorie } from '../../../data/DataDocumentOperationCategorie';
import { DataDocumentOperationType } from '../../../data/DataDocumentOperationType';
import { DataReservation_Echeancier_Stade } from '../../../data/DataReservation_Echeancier_Stade';
import { Immocom } from '../../../specifique/immocom';
import { ComboBoxDocument } from '../../ComboBox/ComboBoxDocument';
import { EUIDatePicker } from '../../EUI/EUIDatePicker';
import { EUIPanel } from '../../EUI/EUIPanel';
import { EUIPercentField } from '../../EUI/EUIPercentageField';
import { EUISeparator } from '../../EUI/EUISeparator';
import { EUITextField } from '../../EUI/EUITextField';
import { ProgressIndicatorChargement } from '../../Loader/ProgressIndicatorChargement';
import { MessageBars } from '../../Outils/MessageBars';
import { SyntheseAppelsDeFonds } from './SyntheseAppelsDeFonds';

export class PanelAppelDeFonds extends Component {

    static defaultProps = {
        idOperation: undefined,
        items: [],
        itemsSelectionnes: [],
        /* --- */
        onDismiss: (rechargerLesDonnees) => null,
        onEnregistrement: () => null
    };

    static defaultState = {
        courrierUniqueSiMemeAdresse: false,
        dateADF: Scriba.date().getChaineISOFromDate(new Date(Date.now()), true),
        estAppelDeFondsEffectue: false,
        rowGUID: undefined,
    };

    constructor(props) {
        super(props);
        this.state = { ...PanelAppelDeFonds.defaultState };
    };

    _enregistrer = () => {
        const { idOperation, itemsSelectionnes, onEnregistrement } = this.props;
        if (itemsSelectionnes.length > 0) {

            this.setState({
                enCoursDeTraitement: true,
                messageEnCoursTraitement: "Enregistrement en cours..."
            });

            const { dateADF } = this.state;
            var reservation_Echeancier_Stades = itemsSelectionnes.map(item => {
                const { idEcheancier, idReservation, idStadeProchainExigible } = item;
                return {
                    idOperation,
                    idReservation,
                    idEcheancier,
                    idStade: idStadeProchainExigible,
                    dateADF
                };
            });

            DataReservation_Echeancier_Stade._onEnregistrementReservation_Echeancier_Stades(reservation_Echeancier_Stades, false)
                .then(responseFetch => {
                    const retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);
                    if (retourVerif === null) {
                        const state = { estAppelDeFondsEffectue: true };
                        Immocom.onReinitStateValeurParDefautEtExecutionDuSetStateEtExecutionCallBack(this, state, onEnregistrement);
                    }
                    else Immocom.onTraitementErreurAvecState(this, {}, retourVerif, responseFetch);
                });
        }
    };

    _onOpen = () => {
        /* 
         * YD : 20221227 : 2221 - chargement static en erreur => si on ne recharge pas, on utilise la même DateADF pour générer le nouvel APF => génère un problème dans 
         * l'ordre de récupération du dernier APF lors du publipostage 
         * Note KP 2023/01/03 : la récupération du dernier ADF s'effectue désormais en fonction du pourcentage cumulé, il n'est plus nécessaire de forcer la mise à jour de l'heure de la dateADF
         * On laisse tel quel néanmoins, ça peut toujours servir (l'heure est de toutes façons positionnée à 0 lorsqu'on sélectionne une date dans le DatePicker)
         * */
        this.setState({
            ...PanelAppelDeFonds.defaultState,
            dateADF: Scriba.date().getChaineISOFromDate(new Date(Date.now()), true),
        });
    };

    _publiposter = () => {
        const { idOperation, itemsSelectionnes, onEnregistrement } = this.props;
        const { estAppelDeFondsEffectue } = this.state;
        if (itemsSelectionnes.length > 0) {

            this.setState({
                enCoursDeTraitement: true,
                messageEnCoursTraitement: "Génération du document en cours..."
            });

            const { courrierUniqueSiMemeAdresse, rowGUID } = this.state;
            var reservation_Echeancier_Stades = itemsSelectionnes.map(item => {
                const { idEcheancier, idReservation, idStadeAppele, idStadeProchainExigible } = item;
                return {
                    idOperation,
                    idReservation,
                    idEcheancier,
                    idStade: estAppelDeFondsEffectue ? idStadeProchainExigible : idStadeAppele,
                };
            });

            // Récupération de l'idDocumentOperationCategorie associé à la catégorie ADV
            // Puis récupération de l'idDocumentOperationType associé à la sous-catégorie Appels de fonds
            DataDocumentOperationCategorie._getDocumentOperationCategorieByName("ADV").then(responseFetch => {
                const retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);
                if (retourVerif === null) {
                    const { idDocumentOperationCategorie } = responseFetch.reponseAPIobjet;

                    DataDocumentOperationType._getDocumentOperationSousCategorieByName(idDocumentOperationCategorie, "Appels de fonds").then(responseFetch => {
                        const retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);
                        if (retourVerif === null) {
                            const { idDocumentOperationType } = responseFetch.reponseAPIobjet;

                            DataReservation_Echeancier_Stade._onPublipostageDocumentADV(reservation_Echeancier_Stades, rowGUID, idDocumentOperationType, courrierUniqueSiMemeAdresse).then(responseFetch => {
                                const retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);
                                if (retourVerif === null) {
                                    const document = responseFetch.reponseAPIobjet || {};
                                    const fichier = Scriba.fichier().Base64VersByteArray(document.fileData || []);
                                    Scriba.fichier().EnregisterSous(fichier, document.nom);
                                    Immocom.onReinitStateValeurParDefautEtExecutionDuSetStateEtExecutionCallBack(this, {}, onEnregistrement);
                                }
                                else Immocom.onTraitementErreurAvecState(this, {}, retourVerif, responseFetch);
                            });

                        }
                        else Immocom.onTraitementErreurAvecState(this, {}, retourVerif, responseFetch);
                    });

                }
                else Immocom.onTraitementErreurAvecState(this, {}, retourVerif, responseFetch);
            });
        }
    };

    render = () => {

        const { idOperation, isOpen, items, itemsSelectionnes, onDismiss } = this.props;
        const { courrierUniqueSiMemeAdresse, dateADF, estAppelDeFondsEffectue, rowGUID } = this.state;

        const estAppelDeFondsRealisable = !!itemsSelectionnes
            && Array.isArray(itemsSelectionnes)
            && itemsSelectionnes.length > 0
            && !!itemsSelectionnes[0].idStadeProchainExigible;

        return <EUIPanel
            customPrimaryButtons={[<PrimaryButton key="imprimer" onClick={this._publiposter} disabled={!rowGUID}>Imprimer</PrimaryButton>]}
            headerText="Appels de fonds"
            isFormValid={estAppelDeFondsRealisable && !estAppelDeFondsEffectue}
            isOpen={isOpen}
            onDismiss={onDismiss}
            onOpen={this._onOpen}
            onSave={this._enregistrer}
            type={PanelType.largeFixed}
        >

            {this.state.enCoursDeTraitement ? <ProgressIndicatorChargement label={this.state.messageEnCoursTraitement} /> : null}

            <MessageBars
                errorMessage={this.state.errorMessage}
                infoMessage={this.state.messageMessageBarFiltres}
                warningMessage={this.state.warningMessage}
                onDismissErrorMessage={() => this.setState({ errorMessage: "" })}
                onDismissWarningMessage={() => this.setState({ warningMessage: "" })}
            />

            {!!itemsSelectionnes && Array.isArray(itemsSelectionnes) && itemsSelectionnes.length > 0 &&
                <Stack horizontal gap={8}>
                    <Stack.Item grow>
                        <EUITextField
                            label="Stade"
                            readOnly
                            value={itemsSelectionnes[0].nomStadeProchainExigible || "Tous les stades exigibles ont déjà été appelés"}
                        />
                    </Stack.Item>
                    <EUIPercentField
                        label="% av. travaux"
                        readOnly
                        scale={10}
                        value={itemsSelectionnes[0].pourcentageProchainExigible * 100 || undefined}
                    />
                </Stack>
            }

            <Stack horizontal gap={8}>
                <EUIDatePicker
                    label="Date ADF"
                    onSelectDate={date => this.setState({ dateADF: Scriba.date().getChaineISOFromDate(date, true) })}
                    value={dateADF}
                />
                <ComboBoxDocument
                    categorie="ADV"
                    idOperation={idOperation}
                    label="Fichier"
                    onChange={(event, option, index, value, item) => { this.setState({ rowGUID: item.rowGUID }); }}
                    selectedKey={rowGUID}
                    sousCategorie="Appels de fonds"
                    type={TYPES_DOCUMENT.OPERATION}
                />
                <Checkbox
                    checked={courrierUniqueSiMemeAdresse}
                    disabled={!rowGUID}
                    label="En cas d'adresse identique, générer un seul courrier"
                    onChange={(event, checked) => this.setState({ courrierUniqueSiMemeAdresse: checked })}
                    styles={{ root: { alignSelf: "end" } }}
                />
            </Stack>

            <EUISeparator />

            <SyntheseAppelsDeFonds
                items={items}
                itemsSelectionnes={itemsSelectionnes}
            />

        </EUIPanel>;

    };

};